import { render, staticRenderFns } from "./MenuBtn.vue?vue&type=template&id=443fe146&"
import script from "./MenuBtn.vue?vue&type=script&lang=js&"
export * from "./MenuBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports